import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const TrafficLogs = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default TrafficLogs;
